import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../../constants/schema";
import { useErrorHandler } from "../../../../hooks";
import DialogFormBuilder from "../../../../components/dialog-form-builder";
import formSectionService from "../../../../services/form-section.service";

const initialValues = {
  title: "",
  description: "",
  isActive: true,
};
const schema = Yup.object().shape({
    title: yupSchema.title128,
});
const form = [
  {
    _type: "textField",
    name: "title",
    label: "عنوان",
    autoFocus: true,
  },
  {
    _type: "textField",
    name: "description",
    multiline: true,
    rows: 3,
    label: "توضیحات",
    autoFocus: false,
  },
];

export default function FormModalContent({ close, data, parent }) {
  const errorHandler = useErrorHandler();

  const handleSubmit = async (model, { setSubmitting }) => {
    model.formId = parent.id;
    let op;
    if (data?.id) {
      op = await formSectionService.editFormSection(data.id, model);
    } else {
      op = await formSectionService.createFormSection(model);
    }
    const { error } = op;
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };

  return (
    <DialogFormBuilder
      {...{
        close,
        name: "بخش فرم",
        data,
        schema,
        initialValues: {
            ...initialValues,
            ...data
        },
        handleSubmit,
        form,
      }}
    />
  );
}
